import { schema } from "normalizr";

const calendarEventParticipant = new schema.Entity("calendarEventParticipants", {}, { idAttribute: "user_email" });
const arrayOfCalendarEventParticipant = [calendarEventParticipant];

export { calendarEventParticipant, arrayOfCalendarEventParticipant };
